import { Injectable } from '@angular/core';
import { ICampaignsCount } from '@libs/apis';
import { CampaignAccordionConstants } from '../components/campaign-accordion/campaign-accordion.constant';
import { TaxonomyDimension } from '../models/ICampaignFilterContext';
import { TaxonomyFeature } from '../models/TaxonomyFeature';
import { TaxonomyTab } from '../models/TaxonomyTab';

@Injectable({
  providedIn: 'root'
})
export class CampaignAccordionService {
  public activeTaxonomyTab: TaxonomyTab = TaxonomyTab.unmapped;
  public accordions: ICampaignsCount[] = [];
  public groupByDimension!: TaxonomyDimension;
  public geoTestStatusByDimension: Record<string, boolean> = {};
  public showUpdateMappingOverlay = false;

  public clientId = 0;
  public brandId = 0;

  public activeAccordionDimensionValue = '';
  public viewFor = TaxonomyFeature.GA;

  public readonly dataSourceDimension =
    TaxonomyDimension.compositeDataSourceName;

  public readonly noData = CampaignAccordionConstants.noData;
  public readonly tabWiseNoDataMessages =
    CampaignAccordionConstants.tabWiseNoDataMessages;

  public accordionStateByCampaignType =
    CampaignAccordionConstants.accordionStateByCampaignType;

  public activeIndexChange(event: number | null): void {
    this.accordionStateByCampaignType[
      this.activeTaxonomyTab
    ].activeAccordionIndex = event;
  }

  public handleImageError(event: Event, campaignCount: ICampaignsCount): void {
    const img = event.target as HTMLImageElement;
    if (!img.src.includes('.png')) {
      img.src = `/assets/images/integrations/${campaignCount.dimensionLogoStr?.toLowerCase()}-logo.png`;
    } else {
      img.src = `/assets/images/integrations/default-datasource.svg`;
    }
  }
}
